/** Longueur maximale d'un nom de tag, alignée sur le schéma Zod de createTradeTag. */
export const MAX_TAG_NAME_LENGTH = 50;

/** Normalise un nom de tag saisi : espaces de bord retirés, casse d'origine préservée. */
export function normalizeTagName(raw: string): string {
  return raw.trim();
}

/**
 * Cherche un tag existant dont le nom correspond, à la casse près.
 * Garantit qu'« FOMO » et « fomo » ne créent pas deux lignes de stats distinctes.
 */
export function findExistingTag<T extends { name: string }>(
  tags: T[],
  candidateName: string,
): T | undefined {
  const normalized = normalizeTagName(candidateName).toLowerCase();
  if (!normalized) return undefined;
  return tags.find((tag) => tag.name.trim().toLowerCase() === normalized);
}
